import { BrowserRouter, NavLink, Switch, Route } from 'react-router-dom';
import './App.css';
import Dashboards from './Components/Header/Dashboards';
import Issues from './Components/Header/Issues';
import IssuesInfo from './Components/Header/Issues/IssuesInfo';
import PaygateDisputes from './Components/Header/PaygateDisputes/PaygateDisputes';
import Customers from './Components/Header/Customer';
import NavBar from './Components/NavComponent';
import TemplatesComponent from './Components/Header/Template';
import InfoCustomerPayment from './Components/Header/Customer/InfoCustomerPayment';
import CaseIdInfo from './Components/Header/PaygateDisputes/CaseInfo/CaseIDInfo';
import NewCaseIdInfo from './Components/Header/PaygateDisputes/NewCase';
import InfoTemplates from './Components/Header/Template/InfoTemplate';
import TableCustomerIssue from './Components/Header/Issues/TableIssue/TableCustomerIssue';
function App() {
	return (
			<BrowserRouter>
				<NavBar />
				<Switch>
					<Route exact path="/issues" component={Issues} />
					<Route exact path="/dashboards" component={Dashboards} />
					<Route exact path="/paygate-disputes" component={PaygateDisputes} />
					<Route exact path="/customers" component={Customers} />
					<Route exact path="/templates" component={TemplatesComponent} />
					<Route exact path="/customers/info-payments">
						<InfoCustomerPayment />
					</Route>
					<Route exact path="/paygate-disputes/case-info" component={CaseIdInfo} />
					<Route exact path="/paygate-disputes/new-ticket" component={NewCaseIdInfo} />
					<Route exact path="/templates/template-info" component={InfoTemplates}/>
					<Route exact path="/issues/issue-info" component={IssuesInfo}/>
					<Route
							exact
								path="/issues/issue-infomation"
								component={TableCustomerIssue}
							/>
				</Switch>
			</BrowserRouter>
	);
}

export default App;
